import { render, staticRenderFns } from "./FamilyManage.vue?vue&type=template&id=7cc0c65e&scoped=true&"
import script from "./FamilyManage.vue?vue&type=script&lang=js&"
export * from "./FamilyManage.vue?vue&type=script&lang=js&"
import style0 from "./FamilyManage.vue?vue&type=style&index=0&id=7cc0c65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0c65e",
  null
  
)

export default component.exports